module.exports = __webpack_public_path__ + "img/9791196178604.dbfa22c8.jpg";